import { Form, Formik, FormikHelpers } from 'formik';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useCheckTestAttemptMutation, useGetTestCheckByIdQuery } from 'src/services/TestCheckServices';
import SingleViewForm from './SingleViewForm';
import { showToast } from 'src/utils/showToaster';
import { object } from 'yup';
import { CircularProgress } from '@mui/material';

const SingleViewFormWrapper = () => {
    const navigate = useNavigate()
    const { id = "" } = useParams();
    const [testCheckData, setTestCheck] = useState<any>({});

    const [checkTestAttempt] = useCheckTestAttemptMutation();

    const { data, isLoading, isFetching } = useGetTestCheckByIdQuery({
        id: id,
    }, { skip: !id });

    useEffect(() => {
        if (!isLoading && !isFetching) {
            setTestCheck(data?.data);
        }
    }, [data, isLoading, isFetching]);

    const initialValues: any = {
        response: testCheckData?.response?.map((questions: any) => questions)
    };

    // Validation Schema
    const validationSchema = object().shape({

    });

    // Handle Submit
    const handleSubmit = (
        values: any,
        { setSubmitting }: FormikHelpers<any>
    ) => {
        const formatedValue = {
            response: values?.response?.map((question: any) => {
                return (
                    {
                        questionId: question?.question?.questionId,
                        score: question?.score
                    }
                )
            }),
            testAttemptId: id || '',
            isChecked: true
        };
        checkTestAttempt(formatedValue).then((res: any) => {
            if (res?.error) {
                showToast("error", res?.error?.data?.message);
            } else {
                if (res?.data?.status) {
                    showToast("success", res?.data?.message);
                    navigate('/test-module/test-check/')
                } else {
                    showToast("error", res?.data?.message);
                }
            }
            setSubmitting(false);
        });
    };
    return (
        <div>
            <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {(formikProps) => (
                    <Form className="h-full overflow-hidden contents">
                        {(isLoading || isFetching) && (
                            <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                                <CircularProgress />
                            </div>
                        )}
                        <SingleViewForm
                            testAttemptedData={testCheckData}
                            formikProps={formikProps}
                        />
                    </Form>
                )}
            </Formik>

        </div>
    )
}

export default SingleViewFormWrapper